(function ($, _, w) {

    const assetId = '~/Parts/Views/Site/Search.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {
        const controlId = ctx.controlID;
        const searchUrl = ctx.settings.searchUrl;

        const $searchCont = $("#" + ctx.containerID);
        const $searchInput = $(".js-" + controlId + "-input", $searchCont);
        const $searchButton = $(".js-" + controlId + "-btn", $searchCont);

        function getQueryVariable(queryVariableName) {
            const query = window.location.search.substring(1);
            const vars = query.split("&");
            for (let i = 0; i < vars.length; i++) {
                const pair = vars[i].split("=");
                if (pair[0] === queryVariableName) {
                    return pair[1];
                }
            }
            // it will return 'undefined' if there is no variable in query string
            return undefined;
        }

        // restore search string from query string
        var previousSearchStr = getQueryVariable("s");
        if (previousSearchStr) {
            // decodeURIComponent can throw exception (SCRIPT5025: The URI to be decoded is not a valid encoding)
            try {
                $searchInput.val(decodeURIComponent(previousSearchStr));
            } catch (e) { }
        }

        $searchInput
            // handle pressing 'Enter' key, emulate search button click
            .keypress(function (e) {
                var code = e.keyCode || e.which;
                if (code === 13) {
                    e.preventDefault();
                    $searchButton.trigger("click");
                }
            });

        $searchButton
            // handle search button click
            .click(function () {
                var term = $searchInput.val().trim();
                if (term) {
                    w.location = searchUrl + encodeURIComponent(term);
                }
            });
    }

})(jQuery, _, window);